/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { memo, useCallback } from 'react';
import { BUTTON } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/action-subject-type.tsx';
import { FIXED_ITEM } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/component-type.tsx';
import { MEATBALL_DROPDOWN } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/item-id.tsx';
import { LEVEL_ONE } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/constants/analytics/level.tsx';
import {
	type OnCloseProps,
	L1_MENU_ID,
} from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/common/types.tsx';
import { HideL1MenuItemSection } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/hide-l1-menu-item-action/index.tsx';
import { MoreNavMenuButton } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/more-nav-menu-button/main.tsx';
import type { MoreNavMenuButtonMenuItemsProps } from '@jira/navigation-apps__sidebar-nav4-sidebars-common-core/src/ui/more-nav-menu-button/submenu/index.tsx';
import MenuGroup from '@atlaskit/menu/menu-group';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { useFilterActionsAnalytics } from '../../utils/analytics/index.tsx';

const filters = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-filters.common.action-buttons.filters',

	defaultMessage: 'Filters',
	description:
		'Name of the Filters section in the sidebar. Used for accessibility labels and tooltips.',
});

type ActionButtonsProps = OnCloseProps;

export const ActionButtons: React.MemoExoticComponent<
	({ onClose }: ActionButtonsProps) => React.JSX.Element
> = memo(({ onClose }: ActionButtonsProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const sendFilterAnalytics = useFilterActionsAnalytics();
	const sendMeatballAnalytics = useCallback(() => {
		sendFilterAnalytics(BUTTON, {
			level: LEVEL_ONE,
			componentType: FIXED_ITEM,
			itemId: MEATBALL_DROPDOWN,
		});
	}, [sendFilterAnalytics]);
	return (
		<MoreNavMenuButton
			onOpen={sendMeatballAnalytics}
			MenuItems={MoreMenuItems}
			onClose={onClose}
			name={formatMessage(filters)}
		/>
	);
});

function MoreMenuItems(_: MoreNavMenuButtonMenuItemsProps) {
	return (
		<MenuGroup>
			<HideL1MenuItemSection menuId={L1_MENU_ID.FILTERS} hasSeparator={false} />
		</MenuGroup>
	);
}
